import {BrowserModule} from "@angular/platform-browser"
import {NgModule} from "@angular/core"
import {ScrollToModule} from "@nicky-lenaers/ngx-scroll-to"

import {AppRoutingModule} from "./app-routing.module"

import {AppComponent} from "./app.component"
import {ShellComponent} from "./shell/shell.component"
import {BlankComponent} from "./shell/blank/blank.component"
import {HttpClientModule} from "@angular/common/http"
import {BrowserAnimationsModule} from "@angular/platform-browser/animations"
import {ReactiveFormsModule} from "@angular/forms"
import {LoginComponent} from "./login/login.component"
import {ResetComponent} from "./reset/reset.component"
import {ResetRequestComponent} from "./reset-request/reset-request.component"
import {DisclaimerComponent} from "./components/disclaimer.component"
import {DialogModule} from "@angular/cdk-experimental/dialog"
import {RedirectGuard} from "src/app/redirect/RedirectGuard"

@NgModule({
    declarations: [
        AppComponent,
        ShellComponent,
        BlankComponent,
        LoginComponent,
        ResetComponent,
        ResetRequestComponent,
        DisclaimerComponent
    ],
    entryComponents: [
        DisclaimerComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        DialogModule,
        ScrollToModule.forRoot()
    ],
    providers: [RedirectGuard],
    bootstrap: [AppComponent]
})
export class AppModule {
}
